export default __webpack_public_path__ + "static/media/napaProgramsLogo_en.b1b1ff4a.svg";